<script setup lang="ts">
import InsightCard from './parts/InsightCard.vue';

defineProps<{
  hasNoData?: boolean;
  title?: string;
}>();
</script>
<template>
  <div class="flex flex-col box-border pt-2 px-4 justify-between color-[#4F4F4F] bg-[#CFD6E2] rounded-1 w-100%">
    <div v-if="title" class="xl:text-4 xs:text-5 font-700 font-family[Poppins]">
      {{ title }}
    </div>
    <div v-else class="inline-block loading-gradient h-[25px] w-23% rounded-2"></div>
    <div class="mb-4 font-family[Roboto]">
      <div class="mt-2 bg-[#FFFFFF] rounded-1">
        <InsightCard :showHasNoDataMessage="hasNoData" />
      </div>
      <div class="mt-2 bg-[#FFFFFF] rounded-1">
        <InsightCard :showHasNoDataMessage="false" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.loading-gradient {
  border-radius: 20px;
}
</style>
